import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';

import { NavController, Platform } from '@ionic/angular';
import { StringUtils } from '@shared/utils/StringUtils';
import { UtilsService } from 'abp-ng2-module/dist/src/utils/utils.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MobileGuard {
    static platform: any;
    constructor(
        private router: Router,
        private platform: Platform,
    ) {
        this.platform = platform;
    }
    static getIsMobile(){
        if (StringUtils.isMobilePlatform(this.platform)) {
           console.log('is mobile true');
            return true;
          } else {
            console.log('is mobile false');
            return false;
          }
    }
}